/* AIX todos: the checklist in brain/aixinternal/todos.md, bundled at build time (edit the file; a deploy picks it up).
   Open items first in file order, done items fold into the quiet line; `o` opens the item's link or the file. */
import { EDensity, EVerdict } from "../homeDashboard.types"
import type { IWidgetDefinition, IWidgetResult, IWidgetRow } from "../homeDashboard.types"
import { parseTodos } from "../todosModel"
import { REPO_BLOB } from "./WidgetParts"

const TODOS_PATH = "brain/aixinternal/todos.md"

const [TODOS_MD = ""] = Object.values(
  import.meta.glob<string>("../../../../../../brain/aixinternal/todos.md", {
    query: "?raw",
    import: "default",
    eager: true,
  }),
)

const FILE_URL = `${REPO_BLOB}/${TODOS_PATH}`

const ITEMS = parseTodos(TODOS_MD)

const ROWS: IWidgetRow[] = ITEMS.map((item, i) => ({
  // Items have no ids; section + text is stable until someone edits the line
  key: `${item.section}:${item.text}:${i}`,
  company: "aix",
  verdict: item.done ? EVerdict.CLEAR : EVerdict.WATCH,
  pill: { text: item.done ? "done" : item.section || "todo", verdict: item.done ? EVerdict.CLEAR : EVerdict.UNKNOWN },
  title: item.text,
  meta: item.link?.label,
  href: item.link?.url ?? FILE_URL,
  hrefLabel: item.link ? `Open ${item.link.label}` : "Open todos.md",
  quiet: item.done,
}))

const OPEN = ITEMS.filter((item) => !item.done).length

const TODOS_RESULT: IWidgetResult = {
  verdict: OPEN ? EVerdict.WATCH : EVerdict.CLEAR,
  count: `${OPEN} open`,
  rows: ROWS,
  ordered: true,
  empty: `No todos. Add "- [ ] …" lines to ${TODOS_PATH}.`,
}

export const aixTodosWidget: IWidgetDefinition = {
  id: "aix-todos",
  title: "AIX todos",
  description: "Command Center and dashboard improvements from brain/aixinternal/todos.md",
  columns: { 2: 2, 3: 3, 4: 4, 5: 5, 6: 6 },
  link: { href: FILE_URL, label: "Edit todos.md" },
  companies: ["aix"],
  defaultDensity: EDensity.COMPACT,
  useWidget: () => ({ result: TODOS_RESULT, isLoading: false, isFetching: false, refetch: () => undefined }),
}
